export var ConfigFeatureFlags = {
    disputesLink: 'disputesLink',
    disputesFooterLink: 'disputesFooterLink',
    postTransactionInstallment: 'postTransactionInstallment',
    previewEnhancements: 'previewEnhancements',
    promotionsLink: 'promotionsLink',
    spendingTrends: 'spendingTrends'
};
//# sourceMappingURL=service-config-types.js.map